"use client";

import { Button } from "@/components/ui/button";
import { Phone, MessageCircle } from "lucide-react";
export default function QuickConnect() {
  return <section data-section-id="236475" id="quick-connect" className="relative w-full py-24 md:py-32 lg:py-40 overflow-hidden bg-primary dark">
      {}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 35px,
            rgba(255, 255, 255, 0.1) 35px,
            rgba(255, 255, 255, 0.1) 70px
          )`
    }} />

      {}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        {}
        <h1 className="font-default text-6xl sm:text-7xl lg:text-8xl font-bold text-primary-foreground tracking-tighter text-center mb-8 lg:mb-12">
          Ready to Start?
        </h1>

        {}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center w-full max-w-2xl">
          {}
          <Button size="lg" className="w-full sm:w-auto h-12 sm:h-14 px-8 sm:px-12 text-lg font-bold bg-primary-foreground text-primary hover:bg-secondary hover:text-secondary-foreground transition-colors duration-300 rounded-md shadow-lg" onClick={() => window.location.href = "tel:1800BEACON"}>
            <Phone className="w-5 h-5" />
            Call Advisor
          </Button>

          {}
          <Button size="lg" className="w-full sm:w-auto h-12 sm:h-14 px-8 sm:px-12 text-lg font-bold bg-primary-foreground text-primary hover:bg-secondary hover:text-secondary-foreground transition-colors duration-300 rounded-md shadow-lg" onClick={() => window.open("https://wa.me/finance", "_blank")}>
            <MessageCircle className="w-5 h-5" />
            Quick Message
          </Button>
        </div>

        {}
        <p className="font-default text-primary-foreground/80 text-center mt-8 sm:mt-12 text-base sm:text-lg max-w-xl tracking-wide">
          Connect with Beacon Finance Group instantly for expert mortgage guidance and current rates.
        </p>
      </div>
    </section>;
}